exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col_form .input_wrapper[data-v-1630c075]{margin-top:10px;margin-left:0}.col_form .input_wrapper>div label[data-v-1630c075]{width:90px}.link_val[data-v-1630c075]{height:30px;padding:8px;border:1px solid #eeeeee}.link_val .type[data-v-1630c075]{padding-right:8px;border-right:1px solid #eeeeee}.link_val p[data-v-1630c075]{padding:0 8px}\n", ""]);

// exports
